function getItem(key) {
  return localStorage.getItem(key)
}

function setItem(key, value) {
  localStorage.setItem(key, value)
}

function removeItem(key) {
  localStorage.removeItem(key)
}

const TB_APP_USER_ID = 'TB_APP_USER_ID'

export function getUserId() {
  return getItem(TB_APP_USER_ID)
}

export function setUserId(userId) {
  setItem(TB_APP_USER_ID, userId)
}

export function removeUserId() {
  removeItem(TB_APP_USER_ID)
}



// WEBPACK FOOTER //
// ./src/utils/user-id.js